import script from "./ArticleDetailSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleDetailSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ArticleDetailSkeleton.vue?vue&type=style&index=0&id=1a5e68dd&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a5e68dd"]])

export default __exports__